<template>
  <div>
    <div class="text-center mx-auto my-16">
      <div >
        <svg
          width="174"
          height="186"
          viewBox="0 0 174 186"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="86.5116" cy="99.4883" r="86.5116" fill="#E0E0E0" />
          <g clip-path="url(#clip0)">
            <path
              d="M132.998 30.0174C132.143 29.7694 131.651 28.8752 131.899 28.0202L133.453 22.6598C134.929 17.573 131.991 12.2344 126.904 10.7591C121.817 9.28375 116.479 12.222 115.003 17.3086C114.755 18.1639 113.861 18.6559 113.006 18.4078C112.151 18.1598 111.659 17.2658 111.907 16.4106C113.877 9.61628 121.008 5.69205 127.802 7.6626C134.596 9.63315 138.52 16.7636 136.55 23.5578L134.995 28.9182C134.747 29.7735 133.853 30.2654 132.998 30.0174Z"
              fill="#79C6E4"
            />
            <path
              d="M36.3804 162.642H136.643C140.271 162.642 143.212 159.701 143.212 156.073V32.0253C143.212 28.3973 140.271 25.4564 136.643 25.4564H36.3804C32.7524 25.4564 29.8115 28.3973 29.8115 32.0253V156.073C29.8115 159.701 32.7527 162.642 36.3804 162.642Z"
              fill="white"
            />
            <path
              d="M112.04 53.1653C106.55 51.5729 103.379 45.8105 104.971 40.3203L111.906 16.4085C112.154 15.5533 113.048 15.0613 113.904 15.3093C114.759 15.5574 115.251 16.4514 115.003 17.3066L108.068 41.2181C106.97 45.0012 109.155 48.9714 112.938 50.0686C116.721 51.1658 120.692 48.9808 121.789 45.1977L128.724 21.2862C129.443 18.807 128.011 16.2052 125.532 15.4862C123.053 14.7671 120.451 16.1992 119.732 18.6782L115.45 33.4408C115.202 34.296 114.308 34.788 113.453 34.54C112.598 34.2919 112.106 33.3979 112.354 32.5427L116.635 17.7801C117.85 13.5937 122.244 11.1755 126.43 12.3897C130.616 13.6039 133.035 17.9979 131.82 22.1843L124.885 46.0958C123.293 51.5862 117.531 54.7577 112.04 53.1653Z"
              fill="#79C6E4"
            />
            <path
              d="M120.344 105.655H52.5592C51.2431 105.655 50.1768 104.589 50.1768 103.273C50.1768 101.957 51.2431 100.89 52.5592 100.89H120.344C121.66 100.89 122.726 101.957 122.726 103.273C122.726 104.588 121.66 105.655 120.344 105.655Z"
              fill="#79C6E4"
            />
            <path
              d="M96.3143 121.301H52.5592C51.2431 121.301 50.1768 120.234 50.1768 118.918C50.1768 117.602 51.2431 116.536 52.5592 116.536H96.3143C97.6301 116.536 98.6968 117.602 98.6968 118.918C98.6968 120.234 97.6301 121.301 96.3143 121.301Z"
              fill="#404B58"
            />
            <path
              d="M106.638 136.949H52.5592C51.2431 136.949 50.1768 135.883 50.1768 134.567C50.1768 133.251 51.2431 132.184 52.5592 132.184H106.638C107.954 132.184 109.021 133.251 109.021 134.567C109.021 135.882 107.954 136.949 106.638 136.949Z"
              fill="#404B58"
            />
            <path
              d="M62.4918 82.9967C61.1758 82.9967 60.1094 81.9303 60.1094 80.6142V75.9376C60.1094 74.6216 61.1758 73.5552 62.4918 73.5552C63.8079 73.5552 64.8743 74.6216 64.8743 75.9376V80.6142C64.8743 81.93 63.8082 82.9967 62.4918 82.9967Z"
              fill="#404B58"
            />
            <path
              d="M118.307 82.9967C116.991 82.9967 115.925 81.9303 115.925 80.6142V75.9376C115.925 74.6216 116.991 73.5552 118.307 73.5552C119.623 73.5552 120.69 74.6216 120.69 75.9376V80.6142C120.69 81.93 119.623 82.9967 118.307 82.9967Z"
              fill="#404B58"
            />
            <path
              d="M90.5438 78.438C94.0791 78.438 97.4408 79.9691 99.7671 82.6388C100.632 83.6308 100.528 85.1359 99.5361 86.0002C98.5438 86.8646 97.0396 86.7613 96.1747 85.7693C94.7534 84.1381 92.701 83.2029 90.5435 83.2029C88.3859 83.2029 86.3336 84.1381 84.9123 85.7693C84.0483 86.761 82.5432 86.8646 81.5509 86.0002C80.5591 85.1359 80.4556 83.6308 81.3199 82.6388C83.6468 79.9695 87.0086 78.438 90.5438 78.438Z"
              fill="#404B58"
            />
          </g>
        </svg>
      </div>
      <p
        class="text-2xl mt-16 border-2 rounded border-zt-danger text-zt-danger p-2 font-bold w-3/5 mx-auto"
      >
        <span>{{ rejectedDocuments }}</span>
        <span>
          {{
            $t(
              "message.uploadImageComponent.modals.multipleRejectDocumentRejected"
            )
          }}
        </span>
      </p>
    </div>
    <div
      class="zt-modal-footer flex justify-center lg:justify-end items-center p-4"
    >
      <zt-button
          data-vs-button="rejected-successful-massive"
        class="ml-1"
        @click="$emit('closeRejectModalAndUpdateTasks')"
        >{{
          $t("message.uploadImageComponent.modals.buttonUnderstand")
        }}</zt-button
      >
    </div>
  </div>
</template>
<script>
export default {
  props: ["rejectedDocuments"],
};
</script>
<style lang="scss" scoped></style>
